module.exports = __webpack_public_path__ + "img/yellowSapphire.b53b203.png";